function isPhone(value) {
   return /^(\([0-9]{2}\)\s*|[0-9]{3}\-)[0-9]{5}-[0-9]{4}$/.test(value);
}

function isCpf(value) {
	return /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/.test(value);
}

function isCep(value) {
   return /^[0-9]{5}-[0-9]{3}$/.test(value);
}

function validateCNPJ(cnpj) {
	cnpj = cnpj.replace(/[^\d]+/g,'');
	if(cnpj == '') return false;
	if (cnpj.length != 14)
		return false;
	// Elimina CNPJs invalidos conhecidos
	if (cnpj == "00000000000000" ||
		cnpj == "11111111111111" ||
		cnpj == "22222222222222" ||
		cnpj == "33333333333333" ||
		cnpj == "44444444444444" ||
		cnpj == "55555555555555" ||
		cnpj == "66666666666666" ||
		cnpj == "77777777777777" ||
		cnpj == "88888888888888" ||
		cnpj == "99999999999999")
		return false;

	// Valida DVs
	tamanho = cnpj.length - 2
	numeros = cnpj.substring(0,tamanho);
	digitos = cnpj.substring(tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
	  soma += numeros.charAt(tamanho - i) * pos--;
	  if (pos < 2)
			pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
	if (resultado != digitos.charAt(0))
		return false;

	tamanho = tamanho + 1;
	numeros = cnpj.substring(0,tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
	  soma += numeros.charAt(tamanho - i) * pos--;
	  if (pos < 2)
			pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
	if (resultado != digitos.charAt(1))
		  return false;

	return true;
}

function validateCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g,'');
  if(cpf == '') return false;
  // Elimina CPFs invalidos conhecidos
  if (cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999")
                  return false;
  // Valida 1o digito
  add = 0;
  for (i=0; i < 9; i ++)
          add += parseInt(cpf.charAt(i)) * (10 - i);
          rev = 11 - (add % 11);
          if (rev == 10 || rev == 11)
                  rev = 0;
          if (rev != parseInt(cpf.charAt(9)))
                  return false;
  // Valida 2o digito
  add = 0;
  for (i = 0; i < 10; i ++)
          add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
          rev = 0;
  if (rev != parseInt(cpf.charAt(10)))
          return false;
  return true;
}

function getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
}

module.exports = {
   getStates() {
      return [
         { id: 'AC', text: 'Acre' }, { id: 'AL', text: 'Alagoas' }, { id: 'AP', text: 'Amapá' },
         { id: 'AM', text: 'Amazonas' }, { id: 'BA', text: 'Bahia' }, { id: 'CE', text: 'Ceará' },
         { id: 'DF', text: 'Distrito Federal' }, { id: 'ES', text: 'Espírito Santo' }, { id: 'GO', text: 'Goiás' },
         { id: 'MA', text: 'Maranhão' }, { id: 'MT', text: 'Mato Grosso' }, { id: 'MS', text: 'Mato Grosso do Sul' },
         { id: 'MG', text: 'Minas Gerais' }, { id: 'PA', text: 'Pará' }, { id: 'PB', text: 'Paraíba' },
         { id: 'PR', text: 'Paraná' }, { id: 'PE', text: 'Pernambuco' }, { id: 'PI', text: 'Piauí' },
         { id: 'RJ', text: 'Rio de Janeiro' }, { id: 'RN', text: 'Rio Grande do Norte' }, { id: 'RS', text: 'Rio Grande do Sul' },
         { id: 'RO', text: 'Rondônia' }, { id: 'RR', text: 'Roraima' }, { id: 'SC', text: 'Santa Catarina' },
         { id: 'SP', text: 'São Paulo' }, { id: 'SE', text: 'Sergipe' }, { id: 'TO', text: 'Tocantins' }
      ];
   },
   validateCNPJ: validateCNPJ,
	 validateCPF(value) { return validateCPF(value) },
   isPhone(value) { return isPhone(value); },

   isPhoneOrNull(value) {
      if (value == undefined || value == null || value == '') return true;
      else return isPhone(value);
   },

   isCnpj(value) {
      return /^[0-9]{2}.[0-9]{3}.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/.test(value);
   },

   isCpf(value) { return isCpf(value); },

   isCep(value) {
      isCep(value);
   },

   isCepOrNull(value) {
      if (value == undefined || value == null || value == '') return true;
      else return isCep(value);
   },
   getFileExtension: getFileExtension
}



// WEBPACK FOOTER //
// ./src/services/util.js